import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import type { SelectFieldProps } from "../Select/SelectField";
import formStyles from "../../features/MainForm/Form.module.css";
import styles from "../Select/Select.module.css";
import "../../styles/animations.css";

interface SelectEventFieldProps extends SelectFieldProps {
  onCurrentProvice: (e: string) => void;
}

export const SelectEventField: React.FC<SelectEventFieldProps> = ({
  label,
  id,
  name,
  getFieldProps,
  onCurrentProvice,
  disabled,
  touched,
  errors,
  options,
  variant = "default",
}) => {
  const { t } = useTranslation();
  const formikProps = getFieldProps(name);

  const selectClass = classNames(styles.selectField, {
    [styles.selectFieldOutlined]: variant === "outlined",
    [styles.selectFieldFilled]: variant === "filled",
    [styles.selectFieldError]: touched?.[name] && errors?.[name],
  });

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onCurrentProvice(e.target.value);
    formikProps.onChange(e);
  };

  return (
    <div className={classNames(formStyles.formGroup, "fadeIn")}>
      <label
        htmlFor={id}
        className={classNames({
          [formStyles.labelGroup]: !disabled,
          [formStyles.labelGroupDisabled]: disabled,
        })}
      >
        {label}
      </label>
      <select
        id={id}
        {...formikProps}
        className={selectClass}
        onChange={handleChange}
        disabled={disabled}
      >
        <option value="" disabled>
          {t("field.select.placeholder")}
        </option>
        {options &&
          options.map((option) => (
            <option key={option.id} value={option.id}>
              {option.value}
            </option>
          ))}
      </select>
      {touched?.[name] && errors?.[name] && (
        <p className={formStyles.formError}>{errors[name]}</p>
      )}
    </div>
  );
};
